/** Mismos topes que backend/limites.py */
export const LEN = {
  observaciones: 500,
  autorizacion: 60,
  motivo: 300,
  naturaleza: 200,
  razonSocial: 120,
  domicilio: 200,
  municipio: 60,
  provincia: 60,
  cp: 10,
  nif: 20,
  nombre: 80,
  dni: 16,
  telefono: 20,
  email: 254,
  matricula: 20,
  alias: 40,
  serie: 10,
  conductor: 80,
  nota: 1000,
  emailSubject: 200,
  emailMessage: 4000,
  vistaNombre: 80,
  precio: 16,
  password: 128,
  sageUrl: 300,
  codigoEmpresa: 40,
  actividad: 80,
  limiteDocumentos: 7,
  limiteUsuarios: 5,
};
